import * as React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import decisionMakerImage from "../../../Assets/Cloudfigma.svg";
import ContactDetailList from "../../AiLeads/ContactDetailList/ContactDetailList";
import RightSidebar from "../../RightSiderbar/RightSiderbar";
import axios from "axios";
import Loader from "../../Loader/Loader";
import {
  APISalesforceUrl,
  APIDataUrl,
  APITokenUrl,
  APIGraphUrl,
  getConfidenceScore,
  GetOktaAuthData,
  GetUserId,
} from "../../../Utils/Utils";
import IndustryDropdown from "../../AiLeads/IndustrySectorDropdown/Index";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import * as XLSX from "xlsx";
import starRed from "../../../Assets/starRed.svg";
import Stargrey from "../../../Assets/Stargrey.png";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import hoveridentifier from "../../../Assets/hoverindentifier.svg";
import moment from "moment";
import MessageModal from "../../MessageModal/MessageModal";
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg";

function Row({
  row,
  connectionStrength,
  setLoading,
  setRowsSelect,
  selectedOuterRows,
  favoritesList,
  setFavoritesList,
  listFavoriteRecords,
  handleRowSelect,
  showLeadsProspects,
}) {
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [dataShortestPath, setDataShortestPath] = React.useState();
  const loggedInUserId = GetUserId();
  const [userDetails, setUserDeatils] = React.useState();
  const navigate = useNavigate();
  const handleRightsidebar = (event) => {
    const data = {};
    data.source_uid = loggedInUserId;
    data.target_uid = Number(event?.person_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIGraphUrl()}/v1/shortest-path`,
    };
    axios(option)
      .then((response) => {
        if (response?.status === 200) {
          const data = Object.values(response.data);
          setDataShortestPath(data);
          setOpenSidebar(true);
          setUserDeatils(event);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handleFavouriteLead = (row) => {
    const data = {
      user_id: Number(GetUserId()),
      people_id: row.person_id,
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/save_favourite_prospect`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        listFavoriteRecords();
        toast.success("Prospect added to favorites");
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleRemoveFavouriteLead = (row) => {
    const data = favoritesList?.find(
      (item) => item?.person_id == row?.person_id
    );
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/remove_favourite_prospect?id=${
        data?.favourites_id
      }`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        listFavoriteRecords();
        toast.success("Prospect removed from favorites");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <TableRow className="juyds" sx={{ "& > *": { borderBottom: "unset" } }}>
      <>
        <TableCell className="checkbox-row-table-inner checkbox-row-table">
          <div className="kjhgf">
            {showLeadsProspects === "leads" ? (
              <input type="checkbox" disabled />
            ) : (
              <input
                type="checkbox"
                onChange={() => handleRowSelect(row)}
                checked={selectedOuterRows.some(
                  (item) => item.person_id === row?.person_id
                )}
              />
            )}
          </div>
        </TableCell>
        <TableCell component="th" scope="row">
          <>
            {favoritesList?.some(
              (item) => item?.person_id == row?.person_id
            ) ? (
              <div
                className="kjhgf"
                onClick={() => handleRemoveFavouriteLead(row)}
              >
                <img src={starRed} alt="" />
              </div>
            ) : (
              <div className="kjhgf" onClick={() => handleFavouriteLead(row)}>
                <img src={Stargrey} alt="" />
              </div>
            )}
          </>
        </TableCell>
        <TableCell className="Decisions-row-tableName-prospect" align="left">
          <div
            className={
              row?.decision_maker === true
                ? "Decision-maker-user-name"
                : "Decision-maker-user-noborder create-name-img"
            }
          >
            <img
              className={
                row?.suspect_status === null
                  ? "hide-image"
                  : row?.journey_status === "project created"
                  ? "decisionMakerImageAi-Decisionmaker-green"
                  : "decisionMakerImageAi-Decisionmaker"
              }
              // src={decisionMakerImage}
              src={
                row?.journey_status === "project created"
                  ? activeSaleforceLogo
                  : decisionMakerImage
              }
              alt=""
            />
            <p className="letter-heading">
              {row?.first_name
                ? row?.first_name
                    ?.split(" ")
                    ?.find((item) => !item.includes("("))
                    ?.charAt(0)
                : ""}
              {row?.last_name
                ? row?.last_name
                    ?.split(" ")
                    ?.find((item) => !item.includes("("))
                    ?.charAt(0)
                : ""}
            </p>
          </div>
        </TableCell>
        <TableCell
          className="Decision-maker-userTeblesell_row"
          align="left"
          onClick={() => {
            navigate(`/Profile/${row?.person_id == 0 ? "0" : row?.person_id}`);
          }}
        >
          <div className="Decision-maker-user-name-main-container">
            <div className="name-and-title-text">
              <div className="fullnameofuser">
                <h3 className="company-name-country">
                  {/* {row?.first_name ? row?.first_name : "-"}  */}
                  {row?.first_name === "jp" ? "JP" : row?.first_name || "-"}
                  &nbsp;
                  {row?.last_name ? row?.last_name : "-"}
                </h3>
              </div>

              <div className="job-title-container">
                <div className="tooltip-container-jobtitle">
                  <p
                    className={
                      row?.raw_job_title
                        ? "tooltip-highlights-jobtitle"
                        : "tooltip-highlights-jobtitle-none"
                    }
                  >
                    {row?.raw_job_title}
                  </p>
                  <p className="after-company-name-country-fordecisionmaker">
                    {row?.primary_job_title?.substring(0, 18) +
                      (row?.primary_job_title?.length > 18 ? "...." : "")}
                  </p>
                </div>
              </div>

              {/* <p className="after-company-name-country-fordecisionmaker">
                {row?.primary_job_title?.substring(0, 18) +
                  (row?.primary_job_title?.length > 18 ? "...." : "")}
              </p> */}
            </div>
          </div>
        </TableCell>
        <TableCell component="th" scope="row">
          <p className="orbit-strength-control">
            {row?.strengthData?.strength ? row?.strengthData?.strength : "-"}
          </p>
        </TableCell>
        <TableCell align="left">
          <h3 className="annual-revenue-table">
            {row.primary_organization ? row.primary_organization : "-"}
          </h3>
        </TableCell>
        <TableCell
          align="left"
          className="table-cell-of-contact-details-dropdown-th"
        >
          <div
            className="Set-dropdown-ofIndustry"
            style={{ position: "relative" }}
          >
            <div className="email-andrelative-other-info">
              <div className="maked-component-of-dropdown-forai-leads">
                <IndustryDropdown row={row} />
              </div>
            </div>
          </div>
        </TableCell>
        <TableCell align="left">
          <div className="Suspect-table-data">
            <h3 className="industry-sector-table">
              {row?.suspect_status ? row.suspect_status : "-"}
            </h3>
          </div>
        </TableCell>
        <TableCell
          align="left"
          className="table-cell-of-contact-details-dropdown-th-prospect"
        >
          <div
            className="Set-dropdown-ofContactDetailList"
            style={{ position: "relative" }}
          >
            <div className="email-and-other-infodc">
              <div className="maked-component-of-dropdown">
                <ContactDetailList item={row} />
              </div>
            </div>
          </div>
        </TableCell>
      </>
      <TableCell className="table-cellhandleRightsidebar-prospect">
        <div
          className="table-cellhandleRightsidebar"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            className="button-collapse-table-propect"
          >
            <RightSidebar
              dataShortestPath={dataShortestPath}
              openSidebar={openSidebar}
              userDetails={userDetails}
              handleRightsidebar={handleRightsidebar}
              rowid={row}
            />
          </IconButton>
        </div>
      </TableCell>

      <TableCell>
        <td className="confience-score-icons">
          {" "}
          {/* Ensures proper positioning */}
          <div className="hover-container-prospects">
            <img
              src={hoveridentifier}
              alt=""
              className="hover-image-prospects"
            />

            <div
              className={`hover-content-prospects ${
                !row?.updated_at || !row?.confidence_score
                  ? "no-update-prospects"
                  : "has-update-prospects"
              }`}
            >
              <div className="data-sync-c-rate-prospects">
                <div className="datasync-line-c-score-prospects">
                  <span className="datasync-line-prospects">Data Sync: </span>
                  <span className="datasync-line-data-prospects">
                    {row?.updated_at
                      ? moment(row.updated_at).format("MM.DD.YY")
                      : "No update information available"}
                  </span>
                </div>
                <div className="datasync-line-c-score-prospects">
                  <span className="datasync-line-prospects">
                    Data Confidence Score:
                  </span>
                  <span className="datasync-line-data-prospects">
                    {row?.confidence_score
                      ? getConfidenceScore(row.confidence_score)
                      : "No update information available"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </TableCell>
    </TableRow>
  );
}
Row.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  connectionStrength: PropTypes.string.isRequired,
};
export default function Prospects({
  isDecisionMakerExcel,
  isSalesForceTrigger,
  setIsSalesForceTrigger,
  setIsDecisionMakerExcel,
  archiveRecord,
  setArchiveRecord,
  setLoading,
  trackRecord,
  setTrackRecord,
  selectedOuterRows,
  setSelectedOuterRows,
  setShowSalesForce,
  showLeadsProspects,
  trackingData,
  handleTrackingdata,
}) {
  const userInfo = GetOktaAuthData();
  const loggedUser = userInfo?.user?.profile;
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [rowsSelect, setRowsSelect] = React.useState({});
  // const [selectedOuterRows, setSelectedOuterRows] = React.useState([])
  const [favoritesList, setFavoritesList] = React.useState([]);
  const [hitApi, setHitApi] = React.useState(false);
  const [rowsSelectAll, setRowsSelectAll] = React.useState(false);
  const [messageModal, setMessageModal] = React.useState(false);
  const [messageModalTrack, setMessageModalTrack] = React.useState(false);
  const [messageModalSalesforce, setMessageModalSalesforce] =
    React.useState(false);
  const loggedInUserId = GetUserId();

  const getStrength = async (e) => {
    const tuples = e.map((item) => ({
      items: [loggedInUserId?.toString(), item.person_id?.toString()],
    }));
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIGraphUrl()}/v1/conn_strength`,
    };
    try {
      const response = await axios(options);
      const strengthData = response?.data;
      const updatedData = e?.map((item, index) => ({
        ...item,
        strengthData: strengthData[index],
      }));
      setFavoritesList(updatedData);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
    }
  };

  const handleRowSelect = (row) => {
    setSelectedOuterRows((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) => item.person_id === row.person_id
      );

      if (isAlreadySelected) {
        return prevSelectedRows.filter(
          (item) => item.person_id !== row.person_id
        );
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };

  React.useEffect(() => {
    if (rowsSelectAll) {
      const allRows = [...favoritesList];
      setSelectedOuterRows(allRows);
    } else if (rowsSelectAll === false) {
      setSelectedOuterRows([]);
    } else if (selectedOuterRows?.length == favoritesList?.length) {
      setRowsSelectAll(true);
    } else if (selectedOuterRows?.length < favoritesList?.length) {
      setRowsSelectAll(false);
    }
  }, [rowsSelectAll, rowsSelect]);

  React.useEffect(() => {
    if (selectedOuterRows?.length) {
      setHitApi(true);
    } else {
      setHitApi(false);
    }
  }, [selectedOuterRows]);
  React.useEffect(() => {
    if (archiveRecord == true) {
      if (hitApi == true) {
        setMessageModal(true);
        setArchiveRecord(false);
      }

      // handleArchiveRecords()
    }
  }, [archiveRecord]);
  const listFavoriteRecords = async () => {
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/list_favourite_prospects?userid=${Number(
        GetUserId()
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      getStrength(response?.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    listFavoriteRecords();
  }, []);
  const handleRemoveFavouriteLead = (row) => {
    setLoading(true);
    const data = favoritesList?.find(
      (item) => item?.person_id == row?.person_id
    );
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/remove_favourite_prospect?id=${
        data?.favourites_id
      }`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleArchiveRecords = async () => {
    setLoading(true);
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to archive");
      setArchiveRecord(false);
      return;
    } else {
      await Promise.all(
        selectedOuterRows.map((i) => handleRemoveFavouriteLead(i))
      );
      const data = selectedOuterRows.map((item) => ({
        user_id: Number(GetUserId()),
        people_id: item?.person_id,
      }));

      const options = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APITokenUrl(),
        },
        data: data,
        url: `${APIDataUrl()}/v1/send_archive`,
      };
      try {
        const response = await axios(options);
        setMessageModal(false);
        setArchiveRecord(false);
        setSelectedOuterRows([]);
        if (response?.data?.message === "Already archived") {
          toast.success("Prospects already Archived.");
        } else {
          listFavoriteRecords();
          toast.success("Prospects Archived Successfully");
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      } finally {
      }
    }
  };
  const handleTrackRecords = () => {
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to track");
      setTrackRecord(false);
      return;
    } else {
      setLoading(true);
      const filteredData = selectedOuterRows.filter(
        (selectedItem) =>
          !trackingData.some(
            (trackingItem) =>
              Number(selectedItem.person_id) === Number(trackingItem.person_id)
          )
      );

      if (filteredData.length === 0) {
        toast.error("All selected records are already tracked.");
        setLoading(false);
        return;
      }

      const data = filteredData.map((item) => item?.person_id);
      // const data = selectedOuterRows.map(item => item?.person_id);
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APITokenUrl(),
        },
        data: data,
        url: `${APIDataUrl()}/v1/save_tracking_prospect?user_id=${Number(
          GetUserId()
        )}`,
      };
      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            setTrackRecord(false);
            setSelectedOuterRows([]);
            setMessageModalTrack(false);
            handleTrackingdata();
            toast.success("Tracking Added");
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  };

  React.useEffect(() => {
    if (trackRecord === true) {
      // Check if showLeadsProspects is "leads"
      if (showLeadsProspects === "leads") {
        if (hitApi === true) {
          setMessageModalTrack(true);
          setTrackRecord(false);
        }
        return;
      }
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to track");
        setTrackRecord(false);
        return;
      } else if (hitApi === true) {
        setMessageModalTrack(true);
        setTrackRecord(false);
      }
      // handleTrackRecords()
    }
  }, [trackRecord]);

  // React.useEffect(() => {
  //   if (trackRecord == true) {
  //     if (!selectedOuterRows?.length) {
  //       toast.error("Please select records to track")
  //       setTrackRecord(false)
  //       return
  //     } else if (hitApi == true) {
  //       setMessageModalTrack(true)
  //       setTrackRecord(false)
  //     }
  //     // handleTrackRecords()
  //   }
  // }, [trackRecord])

  const validateSalesforce = () => {
    if (!selectedOuterRows || selectedOuterRows?.length === 0) {
      // toast.error("Please Select Records For Push To Salesforce");
      setIsSalesForceTrigger(false);
      return false;
    }
    return true;
  };
  const pushToSalesForce = () => {
    setLoading(true);

    const ms = {
      updateData: {
        data: selectedOuterRows?.map((item) => ({
          items: [item?.person_id, "Suspect"],
        })),
      },
    };
    const transformedData = selectedOuterRows
      ?.map((i) => {
        const organizationInfo =
          favoritesList.find((org) => org?.org_id === i?.org_id) || {};
        return { ...i, organizationInfo };
      })
      ?.map((item) => ({
        attributes: {
          type: "Lead",
          referenceId: "rec" + item?.person_id,
        },
        LastName: item?.last_name,
        FirstName: item?.first_name,
        Salutation: null,
        Email: item?.email,
        Phone: item?.phone_no,
        Title: item?.primary_job_title,
        Company: item?.primary_organization,
        City: item?.organizationInfo?.location_identifiers?.split(",")[0],
        State: item?.organizationInfo?.location_identifiers?.split(",")[1],
        Country: item?.organizationInfo?.country,
        LeadSource: "JOI",
        Status: "Suspect",
        LinkedIn_Profile__c: item?.linkedin,
        Suspect_Source_Detail__c: `${loggedUser?.firstName} ${loggedUser?.lastName}`,
      }));
    const finalJson = { records: transformedData, ...ms };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: finalJson,
      url: `${APISalesforceUrl()}/v1/add_suspects`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        if (response?.status === 200) {
          toast.success("Record has been created");
          setSelectedOuterRows([]);
          setMessageModalSalesforce(false);
          setIsSalesForceTrigger(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  React.useEffect(() => {
    if (isSalesForceTrigger) {
      if (!validateSalesforce()) return;
      if (hitApi == true) {
        setMessageModalSalesforce(true);
      }
    }
  }, [isSalesForceTrigger]);
  React.useEffect(() => {
    if (selectedOuterRows?.length) {
      const data = selectedOuterRows?.filter(
        (item) => item.suspect_status !== null
      );
      if (data?.length) {
        setShowSalesForce("disable");
      } else {
        setShowSalesForce("show");
      }
    } else {
      setShowSalesForce(false);
    }
  }, [selectedOuterRows]);
  return (
    <>
      {favoritesList?.length ? (
        <TableContainer component={Paper} className="ai-leads-table-main">
          <Box
            sx={{ margin: 1 }}
            id="scrollableDiv"
            className="ai-leads-table-inner_favourites"
          >
            <Table aria-label="collapsible table" className="ai-leads-table">
              <TableHead>
                <TableRow className="table-row-ai-leads">
                  <TableCell className="checkbox-row-table-inner checkbox-row-table">
                    <div className="kjhgf">
                      {showLeadsProspects === "leads" ? (
                        <input type="checkbox" disabled />
                      ) : (
                        <input
                          type="checkbox"
                          onChange={(e) => setRowsSelectAll(e?.target?.checked)}
                          checked={rowsSelectAll}
                        />
                      )}
                    </div>
                  </TableCell>
                  <TableCell className="score-row-table">Favorite</TableCell>
                  <TableCell className="Decisions-row-tableName-prospect"></TableCell>
                  <TableCell className="Decisions-row-tableName">
                    <p className="prospect-Name-and-Title-propect">
                      {" "}
                      Name & Title
                    </p>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="DecisionstableStrengthnewclass"
                  >
                    <p className="DecisionstableStrength-strength">
                      Orbit Strength{" "}
                    </p>
                  </TableCell>
                  <TableCell align="left" className="employee-row-tableCompany">
                    <p className="DecisionstableStrength-companynew">
                      {" "}
                      Organization
                    </p>
                  </TableCell>
                  <TableCell align="left" className="annual-row-tableIndustry">
                    Industry/ Sector
                  </TableCell>
                  <TableCell align="left" className="industry-row-tableStatus">
                    <p className="DecisionstableStrength-strength">
                      {" "}
                      Orbit Status
                    </p>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="prospects-row-tableDetails-cd"
                  >
                    <p className="Com-details-prospect"> Contact Details</p>
                  </TableCell>
                  <TableCell align="left"> </TableCell>
                  <TableCell align="left"> </TableCell>
                </TableRow>
              </TableHead>
              {/* <TableBody>
                  {favoritesList?.map((row, index) => (
                    <React.Fragment key={index}>
                      <Row
                        row={row}
                        selected={selectedRows.includes(row)}
                        onSelect={(firstName) => {
                          const selectedIndex = selectedRows.indexOf(firstName);
                          let newSelected = [];
                          if (selectedIndex === -1) {
                            newSelected = newSelected.concat(
                              selectedRows,
                              firstName
                            );
                          } else if (selectedIndex === 0) {
                            newSelected = newSelected.concat(
                              selectedRows.slice(1)
                            );
                          } else if (selectedIndex === selectedRows.length - 1) {
                            newSelected = newSelected.concat(
                              selectedRows.slice(0, -1)
                            );
                          } else if (selectedIndex > 0) {
                            newSelected = newSelected.concat(
                              selectedRows.slice(0, selectedIndex),
                              selectedRows.slice(selectedIndex + 1)
                            );
                          }
                          setSelectedRows(newSelected);
                        }}
                        connectionStrength={row.connectionStrength}
                        setLoading={setLoading}
                        setRowsSelect={setRowsSelect}
                        selectedOuterRows={selectedOuterRows}
                        favoritesList={favoritesList}
                        setFavoritesList={setFavoritesList}
                        listFavoriteRecords={listFavoriteRecords}
                        handleRowSelect={handleRowSelect}
                      />
                    </React.Fragment>
                  ))}
                </TableBody> */}
              <TableBody>
                {favoritesList
                  ?.sort((a, b) => {
                    if (a.decision_maker === b.decision_maker) {
                      return 0;
                    }
                    return a.decision_maker ? -1 : 1;
                  })
                  .map((row, index) => (
                    <React.Fragment key={index}>
                      <Row
                        row={row}
                        selected={selectedRows.includes(row)}
                        onSelect={(firstName) => {
                          const selectedIndex = selectedRows.indexOf(firstName);
                          let newSelected = [];
                          if (selectedIndex === -1) {
                            newSelected = newSelected.concat(
                              selectedRows,
                              firstName
                            );
                          } else if (selectedIndex === 0) {
                            newSelected = newSelected.concat(
                              selectedRows.slice(1)
                            );
                          } else if (
                            selectedIndex ===
                            selectedRows.length - 1
                          ) {
                            newSelected = newSelected.concat(
                              selectedRows.slice(0, -1)
                            );
                          } else if (selectedIndex > 0) {
                            newSelected = newSelected.concat(
                              selectedRows.slice(0, selectedIndex),
                              selectedRows.slice(selectedIndex + 1)
                            );
                          }
                          setSelectedRows(newSelected);
                        }}
                        connectionStrength={row.connectionStrength}
                        setLoading={setLoading}
                        setRowsSelect={setRowsSelect}
                        selectedOuterRows={selectedOuterRows}
                        favoritesList={favoritesList}
                        setFavoritesList={setFavoritesList}
                        listFavoriteRecords={listFavoriteRecords}
                        handleRowSelect={handleRowSelect}
                        showLeadsProspects={showLeadsProspects}
                      />
                    </React.Fragment>
                  ))}
              </TableBody>
            </Table>
          </Box>
        </TableContainer>
      ) : (
        <div className="ai-leads-table-main">
          <div className="ai-leads-no-data-available-outter">
            <div className="ai-leads-no-data-available">No Data Available</div>
          </div>
        </div>
      )}
      <MessageModal
        open={messageModal}
        setOpen={setMessageModal}
        message={`Are you sure that you want to archive ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        }?`}
        handleSubmit={handleArchiveRecords}
        // favoritesList={favoritesList}
        listFavoriteRecords={listFavoriteRecords}
        length={selectedOuterRows?.length}
      />
      <MessageModal
        open={messageModalTrack}
        setOpen={setMessageModalTrack}
        message={`Are you sure that you want to add ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        } to tracking?`}
        handleSubmit={handleTrackRecords}
        length={selectedOuterRows?.length}
      />
      <MessageModal
        open={messageModalSalesforce}
        setOpen={setMessageModalSalesforce}
        message={`Are you sure that you want to push ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        } to Salesforce?`}
        handleSubmit={pushToSalesForce}
        length={selectedOuterRows?.length}
      />
    </>
  );
}

Row.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  connectionStrength: PropTypes.string.isRequired,
};
